import appConfig from '../../shared/helpers/appConfig';
// Per-brand Stripe configuration keyed by account_source.
// Stripe publishable keys are safe to include in frontend code.
const BRAND_STRIPE_CONFIGS = {
  dahreply: {
    pricingTableId: appConfig('VUE_APP_DAHREPLY_PRICING_TABLE_ID'),
    noTrialPricingTableId: appConfig('VUE_APP_DAHREPLY_NO_TRIAL_PRICING_TABLE_ID'),
    publishableKey: appConfig('VUE_APP_DAHREPLY_PUBLISHABLE_KEY'),
  },
  singabot: {
    pricingTableId: appConfig('VUE_APP_SINGABOT_PRICING_TABLE_ID'),
    noTrialPricingTableId: appConfig('VUE_APP_SINGABOT_NO_TRIAL_PRICING_TABLE_ID'),
    publishableKey: appConfig('VUE_APP_SINGABOT_PUBLISHABLE_KEY'),
  },
};

export function getBrandStripeConfig(accountSource) {
  return (
    BRAND_STRIPE_CONFIGS[accountSource] || {
      pricingTableId: appConfig('VUE_APP_PRICING_TABLE_ID'),
      noTrialPricingTableId: appConfig('VUE_APP_NO_TRIAL_PRICING_TABLE_ID'),
      publishableKey: appConfig('VUE_APP_PUBLISHABLE_KEY'),
    }
  );
}

// Minimum AI-credit top-up per brand — RM20 (dahreply) / SGD7 (singabot),
// expressed in credits since that's the unit the top-up checkout API takes.
const BRAND_MIN_TOPUP_CREDITS = {
  dahreply: 10000,
  singabot: 11000,
};

export function getBrandMinTopUpCredits(accountSource) {
  return (
    BRAND_MIN_TOPUP_CREDITS[accountSource] || BRAND_MIN_TOPUP_CREDITS.dahreply
  );
}

// Billing currency per brand, for display only (e.g. the top-up price column).
const BRAND_CURRENCY_LABEL = {
  dahreply: 'RM',
  singabot: 'SGD',
};

export function getBrandCurrencyLabel(accountSource) {
  return BRAND_CURRENCY_LABEL[accountSource] || BRAND_CURRENCY_LABEL.dahreply;
}
